'use client';

import { useReducer } from 'react';

interface State {
  isSaving: boolean;
  isError: boolean;
}

export const ACTIONS = {
  START_SAVING: 'START_SAVING',
  SAVE_SUCCESS: 'SAVE_SUCCESS',
  SAVE_ERROR: 'SAVE_ERROR',
};

type Action =
  | { type: (typeof ACTIONS)['START_SAVING'] }
  | { type: (typeof ACTIONS)['SAVE_SUCCESS'] }
  | { type: (typeof ACTIONS)['SAVE_ERROR'] };

const initialState: State = {
  isSaving: false,
  isError: false,
};

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ACTIONS.START_SAVING:
      return {
        isSaving: true,
        isError: false,
      };
    case ACTIONS.SAVE_SUCCESS:
      return {
        isSaving: false,
        isError: false,
      };
    case ACTIONS.SAVE_ERROR:
      return {
        isSaving: false,
        isError: true,
      };
    default:
      return state;
  }
};

/**
 * ### useMutationReducer
 *
 * @description
 * A hook that handles mutation API changes by providing a standardized reducer and actions
 *
 * @example
 * const [state, dispatch] = useMutationReducer();
 * dispatch({ type: MUTATION_ACTIONS.START_SAVING });
 * dispatch({ type: MUTATION_ACTIONS.SAVE_SUCCESS });
 * dispatch({ type: MUTATION_ACTIONS.SAVE_ERROR });
 *
 * @returns The mutation reducer state and dispatch function
 */
const useMutationReducer = () => useReducer(reducer, initialState);

export default useMutationReducer;
